export default __webpack_public_path__ + "static/media/vatDisclaimer.2ecf8fa2.pdf";